const PRODUCT_SLUG_PLACEHOLDER_MAP = {
  'amc-8': 'triangles',
  'amc-12': 'triangles',
  gre: 'triangles',
  'finra-sie': 'warrants',
  'finra-series-6': 'registration',
  'finra-series-7': 'warrants',
  'finra-series-63': 'registration',
  'finra-series-65': 'jurisdiction',
  'finra-series-66': 'registration',
  'usmle-step-1': 'glycolysis',
};
const getPlaceholder = (product) => {
  const { slug } = product;
  const placeholder = PRODUCT_SLUG_PLACEHOLDER_MAP[slug] || 'warrants';
  return placeholder;
};

export default getPlaceholder;
